import { render, staticRenderFns } from "./TestResponseReview.vue?vue&type=template&id=7957c0bb"
import script from "./TestResponseReview.vue?vue&type=script&lang=js"
export * from "./TestResponseReview.vue?vue&type=script&lang=js"
import style0 from "./TestResponseReview.vue?vue&type=style&index=0&id=7957c0bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports